import {__} from "./__";

export const getEmailPlaceholders = () => {
    return {
        '{invoice.pdf_link}': __('Verejný odkaz na stiahnutie faktúry'),
        '{owner.name}': __('Názov eshopu'),
        '{owner.email}': __('Email eshopu'),
    };
};
